import React from 'react';
import { Redirect } from 'react-router-dom';
import { ANALYTICS_ORDERS } from '../../config/routes';

export default () => <Redirect to={ANALYTICS_ORDERS} />;
